import { useMemo } from 'react';

const toCamelCase = (str: string | undefined): string => {
  if (!str) {
    return '';
  }

  let newStr = '';
  const capitals: any[] = [];

  for (let index = 0; index < str.length; index++) {
    if (str[index] == str[index].toUpperCase()) {
      capitals.push(str[index]);
    }
  }

  if (capitals.length == 0) {
    return str;
  }

  if (capitals.length == 1) {
    // determine if capital is at the start
    if (str[0] == str[0].toUpperCase()) {
      return str.toLowerCase();
    } else {
      return str;
    }
  }

  if (capitals.length == 2) {
    let found = 0;
    for (let i = 0; i < str.length; i++) {
      const character = str.charAt(i);
      if (character === character.toLowerCase()) {
        found = i;
        break;
      }
    }

    return str.substring(0, found).toLowerCase() + str.substring(found);
  }

  //If here, there are more than 2 capitals in string
  //lowercase all letters up to first lowercase
  let foundRemainingCapital = 0;
  for (let i = 0; i < str.length; i++) {
    const character = str.charAt(i);
    if (character === character.toLowerCase()) {
      foundRemainingCapital = i;
      break;
    }
  }
  newStr = str.substring(0, foundRemainingCapital).toLowerCase() + str.substring(foundRemainingCapital);

  const remainingCapitals: any[] = [];
  for (let remainingCapitalsIndex = 0; remainingCapitalsIndex < newStr.length; remainingCapitalsIndex++) {
    if (newStr[remainingCapitalsIndex] == newStr[remainingCapitalsIndex].toUpperCase()) {
      remainingCapitals.push(newStr[remainingCapitalsIndex]);
    }
  }

  if (remainingCapitals.length == 0 || remainingCapitals.length == 1) {
    return newStr;
  } else {
    //more than 1 remaining capital in newStr
    let lastLowercasedCapital = '';
    let lastLowercasedCapitalIndex = 0;

    for (let middleCapitalsIndex = 0; middleCapitalsIndex < remainingCapitals.length; middleCapitalsIndex++) {
      // find space between 2 capitals
      const capital = remainingCapitals[middleCapitalsIndex];
      const nextCapital = remainingCapitals[middleCapitalsIndex + 1];
      const nextCapitalIndex = newStr.indexOf(nextCapital);

      if (nextCapital == undefined) {
        // reached end of list

        return newStr;
      }

      if (newStr.indexOf(nextCapital) == newStr.indexOf(capital) + 1) {
        // they are next to each other - lowercase next capital
        newStr =
          newStr.substring(0, nextCapitalIndex) +
          newStr.substring(nextCapitalIndex, nextCapitalIndex + 1).toLowerCase() +
          newStr.substring(nextCapitalIndex + 1);
        lastLowercasedCapital = nextCapital;
        lastLowercasedCapitalIndex = nextCapitalIndex;

        continue;
      }

      // Are previous capital and next capital next to each other
      const previousCapitalSubstring =
        newStr.substring(lastLowercasedCapitalIndex - 1, lastLowercasedCapitalIndex) +
        newStr.substring(lastLowercasedCapitalIndex);
      if (previousCapitalSubstring.indexOf(lastLowercasedCapital.toLowerCase()) == 1) {
        const char = newStr.charAt(lastLowercasedCapitalIndex + 1);
        if (char == char.toUpperCase()) {
          // letter after is a capital - make lowercase
          newStr =
            newStr.substring(0, lastLowercasedCapitalIndex) +
            newStr.substring(lastLowercasedCapitalIndex, lastLowercasedCapitalIndex + 2).toLowerCase() +
            newStr.substring(lastLowercasedCapitalIndex + 2);
          lastLowercasedCapital = nextCapital;
          lastLowercasedCapitalIndex = nextCapitalIndex;
        } else {
          // letter before is a capital - make lowercase
          newStr =
            newStr.substring(0, lastLowercasedCapitalIndex - 1) +
            newStr.substring(lastLowercasedCapitalIndex - 1, lastLowercasedCapitalIndex).toLowerCase() +
            newStr.substring(lastLowercasedCapitalIndex);
          lastLowercasedCapital = nextCapital;
          lastLowercasedCapitalIndex = nextCapitalIndex;
        }

        continue;
      } else {
        lastLowercasedCapital = '';
        lastLowercasedCapitalIndex = 0;

        continue;
      }
    }
  }

  return newStr;
};

export const useVigoCamelCase = () => {
  return useMemo(() => ({ toCamelCase }), []);
};
